import React, { useState, useRef, useEffect } from 'react';

import {
  formatPrintedHtml,
  printHtmlInIframe,
} from '~/services/printer/printerUtils';
import { Button, IconPrinterFilled } from 'takeat-design-system-ui-kit';
import {
  Container,
  Header,
  Title,
  Content,
  LeftColumn,
  RightColumn,
  Section,
  SectionTitle,
  TextArea,
  PreviewContainer,
  PreviewFrame,
  ButtonContainer,
} from './styles';

const HtmlTextPreview = ({ html, foodies = true }) => {
  const [htmlText, setHtmlText] = useState('');
  const [formattedHtml, setFormattedHtml] = useState('');
  const iframeRef = useRef(null);

  const handleTextChange = (e) => {
    const text = e.target.value;
    setHtmlText(text);

    if (text && text.trim()) {
      const unescapedText = text
        .replace(/\\n/g, '\n')
        .replace(/\\"/g, '"')
        .replace(/\\'/g, "'");
      const formatted = formatPrintedHtml(unescapedText);
      setFormattedHtml(formatted);
    } else {
      setFormattedHtml('');
    }
  };
  useEffect(() => {
    if (html && html.trim()) {
      const unescapedText = html
        .replace(/\\n/g, '\n')
        .replace(/\\"/g, '"')
        .replace(/\\'/g, "'");
      const formatted = formatPrintedHtml(unescapedText);
      setFormattedHtml(formatted);
    } else {
      setFormattedHtml('');
    }
  }, [html]);

  const handlePrint = () => {
    if (formattedHtml) {
      printHtmlInIframe(iframeRef, formattedHtml);
    }
  };

  return (
    <Container>
      <iframe ref={iframeRef} style={{ display: 'none' }} />
      {foodies && (
        <Header>
          <Title>Teste de Impressão HTML</Title>
        </Header>
      )}

      <Content foodies={foodies}>
        <LeftColumn>
          {foodies && (
            <Section>
              <SectionTitle>HTML de Entrada</SectionTitle>
              <TextArea
                value={htmlText}
                onChange={handleTextChange}
                placeholder="Cole aqui o HTML que deseja testar para impressão..."
              />
            </Section>
          )}
        </LeftColumn>
        <RightColumn>
          <Section>
            {foodies && <SectionTitle>Preview</SectionTitle>}
            <PreviewContainer>
              {formattedHtml ? (
                <PreviewFrame
                  sandbox="allow-scripts"
                  srcDoc={formattedHtml}
                  title="HTML Preview"
                />
              ) : (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '100%',
                    color: '#666',
                    fontSize: '14px',
                    textAlign: 'center',
                    padding: '20px',
                  }}
                >
                  {foodies
                    ? 'Cole o HTML no campo à esquerda para visualizar o preview'
                    : 'Selecione um tipo de impressão para iniciar a configuração'}
                </div>
              )}
            </PreviewContainer>
            <ButtonContainer>
              <Button
                variant="outlined"
                onClick={handlePrint}
                disabled={!formattedHtml}
                icon={<IconPrinterFilled />}
              >
                {foodies ? 'Imprimir HTML' : 'Imprimir teste'}
              </Button>
            </ButtonContainer>
          </Section>
        </RightColumn>
      </Content>
    </Container>
  );
};

export default HtmlTextPreview;
